export const WORKING_STATUS_FADE_MS = 320;

/** First slot is always "Working"; later slots rotate with shorter dwell times. */
export const ROTATING_WORKING_STATUS_MESSAGES = [
  { label: 'Working', durationMs: 2_000  },
  { label: 'Let me take a look', durationMs: 2_000 },
  { label: 'Thinking this through', durationMs: 2_000 },
  { label: 'Analyzing your request', durationMs: 2_000 },
  { label: 'Starting to process your request', durationMs: 2_000 }, 
  { label: 'Taking this on now', durationMs: 2_000 },
] as const;
